import { render } from "./ProjectOffcanvas.vue?vue&type=template&id=79e822d4&scoped=true&ts=true"
import script from "./ProjectOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ProjectOffcanvas.ts?vue&type=script&lang=ts"

import "./ProjectOffcanvas.scss?vue&type=style&index=0&id=79e822d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e822d4"]])

export default __exports__